module.exports = __webpack_public_path__ + "images/logo_vertical_cropped.ea9784dd547fcd1c2a2332fa56bb754f.png";